import React from 'react';

const PrivacyPage = () => {
    return (
        <div>
            <h1>Privacy Policy</h1>
        </div>
    );
};

export default PrivacyPage;
